module.exports = __webpack_public_path__ + "static/img/p1-t5.b51a501.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-t5.png
// module id = 8EEs
// module chunks = 0